import _ from 'lodash'
import React, { useEffect, useState } from 'react'
import { Search } from 'semantic-ui-react'
import axios from 'axios'
import parse from 'html-react-parser';

import { useUIState, useUIDispatch } from '../context/store'

const initialState = {
    isLoading: false,
    results: []
};

function ProductSearchInput({value, onChange, setID}) {
    const {products} = useUIState();
    const dispatch = useUIDispatch();
    const [search, setSearch] = useState(initialState);

    const handleSearchChange = (e, { value }) => {
        onChange(value);
        setSearch(state => ({...state, isLoading: true}));

        setTimeout(() => {
            if (value.length < 1) return setSearch(initialState);
      
            const re = new RegExp(_.escapeRegExp(value), 'i')
            const isMatch = (result) => re.test(result.title)
      
            setSearch({
                ...search,
              isLoading: false,
              results: _.filter(products, isMatch),
            })
        }, 300)
    }

    const handleResultSelect = (e, { result }) => {
        onChange(result.title);
        setID(result.value);
    };

    useEffect(() => {
        const { wp_rest } = window.theme_vars;

        if (products.length <= 0) {
            axios.get(`${wp_rest}social/v1/products`).then(resp => {
                const data = resp.data;
                const options = Object.keys(data).map((x, i) => {
                    return {
                        title:parse(data[x]), 
                        value:x
                    }
                });
                dispatch({type:'STORE_PRODUCTS', payload:options});
            })
        }
    }, [products, dispatch])

    return (
        <Search
            input={{ icon: 'search', iconPosition: 'left' }}
            loading={search.isLoading}
            onResultSelect={handleResultSelect}
            onSearchChange={_.debounce(handleSearchChange, 500, {
              leading: true,
            })}
            results={search.results}
            value={value}
        />
    )
}

export default ProductSearchInput
